import React from 'react'

const Hero = ({title}) => {
  return (
    <div className='hero'>
      <h1>{title}</h1>
    </div>
  )
}

export default Hero
